import Vue from 'vue/dist/vue.esm.js'

import Alert from "./alert.vue";
import Countdown from "./countdown.vue";
import CountrySelector from "./country-selector.vue";
import CvvHelp from "./cvv-help.vue";
import DiscountCoupon from "./discount-coupon.vue";
import FormBillet from "./form-billet.vue";
import FormCreditCard from "./form-credit-card.vue";
import FormGroup from "./form-group.vue";
import FormPix from "./form-pix.vue";
import FormStripe from "./form-stripe.vue";
import FormatMoney from "./format-money.vue";
import LoadingSpinner from "./loading-spinner.vue";
import MultipleOrderBumpDetails from "./multiple-order-bump-details.vue";
import MultipleOrderBump from "./multiple-order-bump.vue";
import PaymentTypeLogos from "./payment-type-logos.vue";
import PaymentTypeSelector from "./payment-type-selector.vue";
import PreviewCreditCard from "./preview-credit-card.vue";
import ResponsiveVideo from "./responsive-video.vue";
import Terms from "./terms.vue";
import TotalToPay from "./total-to-pay.vue";

Vue.component('Alert', Alert);
Vue.component('Countdown', Countdown);
Vue.component('CountrySelector', CountrySelector);
Vue.component('CvvHelp', CvvHelp);
Vue.component('DiscountCoupon', DiscountCoupon);
Vue.component('FormBillet', FormBillet);
Vue.component('FormCreditCard', FormCreditCard);
Vue.component('FormGroup', FormGroup);
Vue.component('FormPix', FormPix);
Vue.component('FormStripe', FormStripe);
Vue.component('FormatMoney', FormatMoney);
Vue.component('LoadingSpinner', LoadingSpinner);
Vue.component('MultipleOrderBumpDetails', MultipleOrderBumpDetails);
Vue.component('MultipleOrderBump', MultipleOrderBump);
Vue.component('PaymentTypeLogos', PaymentTypeLogos);
Vue.component('PaymentTypeSelector', PaymentTypeSelector);
Vue.component('PreviewCreditCard', PreviewCreditCard);
Vue.component('ResponsiveVideo', ResponsiveVideo);
Vue.component('Terms', Terms);
Vue.component('TotalToPay', TotalToPay);